import { useMemo, useSyncExternalStore } from 'react'
import { MOBILE_BREAKPOINT, TABLET_BREAKPOINT, DESKTOP_BREAKPOINT } from '@/utils/constants'
import { useViewportSeed } from '@/utils/viewport-seed'

const subscribe = (notify: () => void) => {
	window.addEventListener('resize', notify)
	return () => window.removeEventListener('resize', notify)
}
const getSnapshot = () => `${window.innerWidth}:${window.innerHeight}`

function useWindowSize(initialWidth = 0, initialHeight = 0) {
	// A stable server snapshot avoids hydration mismatches. When a server
	// page wrapped the tree in ViewportSeed, that hint is the snapshot so
	// the first paint is the phone or desktop layout, not width 0.
	const seed = useViewportSeed()
	const serverWidth = initialWidth || seed?.width || 0
	const serverHeight = initialHeight || seed?.height || 0
	const dimensions = useSyncExternalStore(
		subscribe,
		getSnapshot,
		() => `${serverWidth}:${serverHeight}`
	)
	return useMemo(() => {
		const [width, height] = dimensions.split(':').map(Number)
		return { width, height, isMobile: width < MOBILE_BREAKPOINT,
			isDesktop: width >= TABLET_BREAKPOINT, isLargeDesktop: width >= DESKTOP_BREAKPOINT }
	}, [dimensions])
}

export default useWindowSize
